module.exports = __webpack_public_path__ + "media/images/vehicles/sattelzugmaschiene-6488b2637ebb6414d7a9b06c19dbff28.png";